import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { computed, onMounted } from 'vue'

import { MdmPolicySchema } from '@/generated/sdk'

import { useProvidePolicyConfig } from '..'

export default /*#__PURE__*/_defineComponent({
  __name: 'PolicyEditPage',
  setup(__props) {

const { setPolicyConfig } = useProvidePolicyConfig()

const store = useStore()
const route = useRoute()
const policies = computed<MdmPolicySchema[]>(() => store.state.policies.mdmPolicies)
const currentPolicy = computed<MdmPolicySchema>(() => store.state.policies.currentPolicy)

onMounted(async () => {
  const policyId = route.params.id
  const currentPolicy = policies.value.find(m => m.id === policyId)
  if (currentPolicy) {
    store.commit('setCurrentPolicy', currentPolicy)
    await setPolicyConfig(currentPolicy.configPolicy)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_PolicyConfiguration = _resolveComponent("PolicyConfiguration")!
  const _component_QrCode = _resolveComponent("QrCode")!
  const _component_DodoCard = _resolveComponent("DodoCard")!
  const _component_DodoTabs = _resolveComponent("DodoTabs")!
  const _component_DodoColumn = _resolveComponent("DodoColumn")!

  return (_openBlock(), _createBlock(_component_DodoColumn, null, {
    default: _withCtx(() => [
      _createVNode(_component_DodoRow, null, {
        default: _withCtx(() => [
          _createElementVNode("h1", null, "Policy: " + _toDisplayString(currentPolicy.value?.name || ''), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_DodoTabs, { tabs: [
        { name: 'Configuration', slot: 'configuration' },
        { name: 'Enrollment', slot: 'enrollment' },
      ] }, {
        configuration: _withCtx(() => [
          _createVNode(_component_PolicyConfiguration)
        ]),
        enrollment: _withCtx(() => [
          _createVNode(_component_DodoCard, null, {
            default: _withCtx(() => [
              _createVNode(_component_QrCode, { policy: currentPolicy.value }, null, 8, ["policy"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})